import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export class ConfirmDialogData {
    title: string;
    text: string;
    confirm: string;
    confirmFunction?: Function;
    cancel: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
    }

    ngOnInit() {

    }

    onYesClick() {
        if (this.data.confirmFunction && typeof this.data.confirmFunction === 'function') {
            this.data.confirmFunction();
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}

